import { ref, watch } from "vue";
import { defineStore } from "pinia";

export const LOCAL_STORAGE_KEY = "locale";
const INITIAL_VALUES = {
  locale:
    localStorage.getItem(LOCAL_STORAGE_KEY) ?? navigator.language.slice(0, 2),
  availableLocales: [],
};

export const useLocaleStore = defineStore("locale", () => {
  const locale = ref(INITIAL_VALUES.locale);
  const availableLocales = ref(INITIAL_VALUES.availableLocales);

  watch(locale, (newLocale) => {
    if (newLocale === null) {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY, newLocale);
      document.documentElement.lang = newLocale;
    }
  });

  const reset = () => {
    locale.value = INITIAL_VALUES.locale;
  };

  const setLocale = (newLocale) => {
    locale.value = newLocale;
  };

  const setAvailableLocales = (newAvailableLocales) => {
    availableLocales.value = newAvailableLocales;
  };

  return { locale, availableLocales, reset, setLocale, setAvailableLocales };
});
